<template>
    <div id='logsin' class='row justify-condtent-center'>
      <div class="card-body bg-transparent">
        <div class='card text-white' style="width: 20rem;">
          <form class='p-2' id='needs-validation' v-if='!checking'>
            <div class='form-group'>
              <label for='email'>Email</label>
              <input id='email' class='form-control' type='text' name='email' v-model='input.email' placeholder='Email' required/>
            </div>
            <div class='form-group mdb-3'>
              <label for='password'>Password</label>
              <input id='password' class='form-control' type='password' name='password' v-model='input.password' placeholder='Password' required/>
            </div>
            <div class='form-group mbd-3'>
              <button type='submit' class='btn btn-primary' @click.prevent='login'>Login</button>
            </div>
            <div id='invalidCreds' class='invalid' v-show='!validCreds'>
              <p>
                ✖ Invalid Credentials
              </p>
            </div>
          </form>
          <div class="d-flex justify-content-center mb-3">
            <b-spinner type="grow" label="Loading..." v-if='checking' class="float-middle" style="width: 6rem; height: 6rem;"></b-spinner>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import {AUTH_REQUEST} from '@/store/actions/auth'

export default {
  name: 'Login',
  data  () {
    return {
      validCreds: true,
      checking: false,
      input: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    async login () {
      this.checking = true
      var valid = await this.$store.dispatch(AUTH_REQUEST, this.input)
      if (valid) {
        this.$router.replace({ name: 'cardshome' })
        window.location.reload()
      } else {
        this.checking = false
        this.validCreds = false
      }
    }
  },
  created: () => (console.log('login mounted'))
}
</script>

<style scoped>

.valid {
    color: green;
}
.valid:before {
    content: "✔";
}
.invalid {
    color: red;
}
.card {
  background-color: rgba(0, 0, 0, 0.75);
}

</style>



// WEBPACK FOOTER //
// src/components/login.vue